<div class="controls-container">
    <div class="controls-header">Modals</div>

    <pm-button (Click)="OpenAlertModal()">Open Alert Modal</pm-button>

    <pm-button (Click)="OpenConfirmModal()">Open Confirm Modal</pm-button>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/modals/modals.html